import styled from "styled-components";
import Variables from "../../../../../assets/styleVariables";

export const FormContainer = styled.div`
  margin-top: 16px;
  //max-height: 100%;
  //height: 100%;
  //overflow-y: auto;
  .extra-note {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 8px;
    padding: 0 10px 6px;
  }
  .flex {
    display: flex;
    padding: 0 30px;
    margin: 16px 0;
    align-items: center;
   
    label {
      font-size: 12px;
      font-weight: 500;
      color: ${Variables.colors.complementary_600};
      margin-bottom: 12px;
      display: block;
    }
    .description {
      width: 100%;
      height: 43px;
    }
    .print-info-icon {
      margin-left: 16px;
      cursor: pointer;
      &:before {
        font-size: 24px;
        color: ${Variables.colors.complementary_700};
      }
    }
  }
  .date-box {
    .side-icon {
      margin-top: 36px !important;
    }
  }
  .side-icon {
    margin: 10px 12px 12px 12px;
    color: ${Variables.colors.complementary_900};
    font-size: ${Variables.font_sizes.x2_medium};
  }
`;